import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { getBasicData } from 'modules/framework/editFramework';
import { TModalInfo } from 'modules/learning/boardTypes';
import { Button, Row } from 'antd';
import EditBoardModal from './EditBoardModal';

const EditorHeader = ({ record }: any) => {
  const [isOnModal, setIsOnModal]: any = useState({
    visible: false,
  });
  const [modalInfo, setModalInfo] = useState<TModalInfo>();
  const dispatch = useDispatch();

  useEffect(() => {
    if (modalInfo) {
      dispatch(getBasicData(modalInfo));
    }
  }, [modalInfo]);

  return (
    <>
      <Row style={{ marginBottom: '26px' }}>
        <Button
          onClick={() => {
            setIsOnModal({
              visible: true,
              onFinish: (data: any) => {
                setModalInfo(data);
              },
            });
          }}
        >
          기본 정보 편집
        </Button>
      </Row>
      <EditBoardModal modalState={isOnModal} setModalState={setIsOnModal} record={record} />
    </>
  );
};

export default EditorHeader;
